import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

export default function EmptyLayout({ children }: Props) {
    return <div>{children}</div>;
}
